import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag } from 'lucide-react';
const NAMES = ['María', 'Laura', 'Carolina', 'Gabriela', 'Valeria', 'Silvana', 'Andrea', 'Patricia', 'Sofía', 'Valentina', 'Camila', 'Lucía'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Salta', 'Tucumán', 'Santa Fe', 'Neuquén'];
export function PurchaseNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [notificationData, setNotificationData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      triggerNotification();
    }, 5000);
    return () => clearTimeout(initialTimeout);
  }, []);
  const triggerNotification = () => {
    // Random data
    const name = NAMES[Math.floor(Math.random() * NAMES.length)];
    const city = CITIES[Math.floor(Math.random() * CITIES.length)];
    setNotificationData({
      name,
      city
    });
    setIsVisible(true);
    // Hide after 4 seconds
    setTimeout(() => {
      setIsVisible(false);
      // Schedule next notification (random between 8-15 seconds)
      const nextDelay = Math.floor(Math.random() * (15000 - 8000 + 1) + 8000);
      setTimeout(triggerNotification, nextDelay);
    }, 4000);
  };
  return <AnimatePresence data-id="element-1">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: 0
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} className="fixed bottom-4 right-4 z-50 max-w-xs w-full md:max-w-sm bg-white border-l-4 border-[#D4915D] shadow-lg rounded-r-lg p-4 flex items-center gap-3" data-id="element-2">
          <div className="bg-[#F5F1E8] p-2 rounded-full flex-shrink-0" data-id="element-3">
            <ShoppingBag className="w-5 h-5 text-[#D4915D]" data-id="element-4" />
          </div>
          <div data-id="element-5">
            <p className="text-sm font-medium text-gray-900" data-id="element-6">
              {notificationData.name} de {notificationData.city}
            </p>
            <p className="text-xs text-gray-500" data-id="element-7">
              acaba de comprar este libro digital
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}